import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { Step } from '@app/shared/interfaces/step.interface';

@Component({
    selector: 'app-vertical-step',
    standalone: true,
    imports: [CommonModule, TranslateModule],
    templateUrl: './vertical-step.component.html',
    styleUrl: './vertical-step.component.scss',
})
export class VerticalStepComponent {
    @Input() stepIdSelected: any = 0;
    @Input() stepNumberSelected: any = 0;
    @Input() steps: Step[] = [];

    constructor() {}

    ngOnInit(): void {}
}
